(() => {
const $973b254601fecd3f$var$$ = jQuery;
const $973b254601fecd3f$var$_window = $973b254601fecd3f$var$$(window);
const $973b254601fecd3f$var$Menu = {
    $dom: {
        container: $973b254601fecd3f$var$$("#site-navigation"),
        menu_toggle: $973b254601fecd3f$var$$(".menu-toggle"),
        body: $973b254601fecd3f$var$$("body"),
        menu: undefined,
        links: undefined,
        sub_menus: undefined,
        header: $973b254601fecd3f$var$$("header")
    },
    vars: {
        activated_screen_resolution: 1199,
        show_arrows_on_desktop: false,
        scroll_threshold: 50
    },
    initDom: function() {
        $973b254601fecd3f$var$Menu.$dom.menu = $973b254601fecd3f$var$Menu.$dom.container.find("ul").eq(0);
        $973b254601fecd3f$var$Menu.$dom.links = $973b254601fecd3f$var$Menu.$dom.menu.find("a");
        $973b254601fecd3f$var$Menu.$dom.sub_menus = $973b254601fecd3f$var$Menu.$dom.menu.find("ul");
    },
    appendArrows: function() {
        if ($973b254601fecd3f$var$_window.width() <= $973b254601fecd3f$var$Menu.vars.activated_screen_resolution || $973b254601fecd3f$var$Menu.vars.show_arrows_on_desktop) {
            var items_has_children = $973b254601fecd3f$var$Menu.$dom.container.find("li.menu-item-has-children");
            items_has_children.each(function() {
                if ($973b254601fecd3f$var$$(this).find(".arrow-toggle").length > 0) return;
                var $parent = this;
                var $arrow = $973b254601fecd3f$var$$("<span class='arrow-toggle'><span class='arrow-toggle--icon'></span></span>");
                $973b254601fecd3f$var$$(this).prepend($arrow);
                $arrow.on("click", function() {
                    $973b254601fecd3f$var$$($parent).toggleClass("expandeds");
                    $973b254601fecd3f$var$$($parent).find("> .sub-menu").slideToggle(500);
                });
            });
        } else $973b254601fecd3f$var$$(".arrow-toggle").remove();
    },
    toggleMenu: function() {
        $973b254601fecd3f$var$Menu.$dom.menu_toggle.on("click", function(e) {
            $973b254601fecd3f$var$Menu.$dom.menu_toggle.toggleClass("is-active");
            $973b254601fecd3f$var$Menu.$dom.body.toggleClass("menu-active");
            $973b254601fecd3f$var$Menu.$dom.container.toggleClass("toggled");
            e.stopPropagation();
        });
    },
    closeMenu: function() {
        if ($973b254601fecd3f$var$$(this).attr("href") != "#" && $973b254601fecd3f$var$$(this).attr("href") != "") {
            $973b254601fecd3f$var$Menu.$dom.body.removeClass("menu-active");
            $973b254601fecd3f$var$Menu.$dom.menu_toggle.removeClass("is-active");
            $973b254601fecd3f$var$Menu.$dom.container.removeClass("toggled");
        }
    },
    bindScrollResize: function() {
        $973b254601fecd3f$var$_window.on("resize", function() {
            $973b254601fecd3f$var$Menu.appendArrows();
        });
        $973b254601fecd3f$var$_window.on("scroll", function() {
            if ($973b254601fecd3f$var$_window.scrollTop() > $973b254601fecd3f$var$Menu.vars.scroll_threshold) $973b254601fecd3f$var$Menu.$dom.header.addClass("scrolled");
            else $973b254601fecd3f$var$Menu.$dom.header.removeClass("scrolled");
        });
    },
    bindClicks: function() {
        $973b254601fecd3f$var$$(document).on("click", $973b254601fecd3f$var$Menu.closeMenu);
        $973b254601fecd3f$var$Menu.$dom.links.on("click", $973b254601fecd3f$var$Menu.closeMenu);
        $973b254601fecd3f$var$Menu.toggleMenu();
        $973b254601fecd3f$var$Menu.$dom.container.find("> div").click(function(e) {
            e.stopPropagation();
        });
    },
    init: function() {
        $973b254601fecd3f$var$Menu.initDom();
        $973b254601fecd3f$var$Menu.appendArrows();
        $973b254601fecd3f$var$Menu.bindClicks();
        $973b254601fecd3f$var$Menu.bindScrollResize();
    }
};
var $973b254601fecd3f$export$2e2bcd8739ae039 = $973b254601fecd3f$var$Menu;


const $cb6de554e11ef79b$var$$ = jQuery;
const $cb6de554e11ef79b$var$Theme = {
    dom: {
        shareLink: $cb6de554e11ef79b$var$$(".share-buttons a"),
        smoothScrollLinks: $cb6de554e11ef79b$var$$('a[href*="#"]')
    },
    /**************************************************
    * Share links
    **************************************************/ share: function() {
        $cb6de554e11ef79b$var$$(".share-buttons a").on("click", function(e) {
            if (!$cb6de554e11ef79b$var$$(this).hasClass("btn-email")) {
                e.preventDefault();
                $cb6de554e11ef79b$var$Theme.PopupCenter($cb6de554e11ef79b$var$$(this).attr("href"), $cb6de554e11ef79b$var$$(this).attr("title"), 500, 300);
            }
        });
    },
    /**************************************************
    * Share links popup
    **************************************************/ PopupCenter: function(url, title, w, h) {
        // Fixes dual-screen position                         Most browsers      Firefox
        var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
        var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;
        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
        var left = width / 2 - w / 2 + dualScreenLeft;
        var top = height / 2 - h / 2 + dualScreenTop;
        var newWindow = window.open(url, title, "scrollbars=yes, width=" + w + ", height=" + h + ", top=" + top + ", left=" + left);
        // Puts focus on the newWindow
        if (window.focus) newWindow.focus();
    },
    /**************************************************
    * Smooth scroll
    ***************************************************/ smooth_scroll: function() {
        $cb6de554e11ef79b$var$Theme.dom.smoothScrollLinks// Remove links that don't actually link to anything
        .not('[href="#"]').not('[href="#0"]').click(function(event) {
            // On-page links
            if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
                // Figure out element to scroll to
                var target = $cb6de554e11ef79b$var$$(this.hash);
                target = target.length ? target : $cb6de554e11ef79b$var$$("[name=" + this.hash.slice(1) + "]");
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $cb6de554e11ef79b$var$$("html, body").animate({
                        scrollTop: target.offset().top
                    }, 1000, function() {
                        // Callback after animation
                        // Must change focus!
                        var $target = $cb6de554e11ef79b$var$$(target);
                        $target.focus();
                        if ($target.is(":focus")) // Checking if the target was focused
                        return false;
                        else {
                            $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        }
                    });
                }
            }
        });
    },
    /**************************************************
    * Fix Height on smaller devices
    **************************************************/ fix_mobile_height: function() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
        window.addEventListener("resize", ()=>{
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", `${vh}px`);
        });
    },
    /**************************************************
    * Initial all theme functions
    **************************************************/ init: function() {
        $cb6de554e11ef79b$var$Theme.share();
        $cb6de554e11ef79b$var$Theme.smooth_scroll();
        $cb6de554e11ef79b$var$Theme.fix_mobile_height();
    }
};
var $cb6de554e11ef79b$export$2e2bcd8739ae039 = $cb6de554e11ef79b$var$Theme;


const $8bae1bbaa0bec04d$var$$ = jQuery;
const $8bae1bbaa0bec04d$var$ToTopButton = {
    init: function() {
        this.toTopBtn = document.getElementById("toTopBtn");
        this.setupClickListener();
    },
    setupClickListener: function() {
        this.toTopBtn.addEventListener("click", function(event) {
            event.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        });
    }
};
var $8bae1bbaa0bec04d$export$2e2bcd8739ae039 = $8bae1bbaa0bec04d$var$ToTopButton;


const $cc7923cc3d4263e7$var$$ = jQuery;
const $cc7923cc3d4263e7$var$ShowMore = {
    init: ()=>{
        const filters = document.querySelector(".products-wrapper");
        if (!filters) return;
        const tags = document.querySelectorAll(".product-item");
        const showMore = document.querySelector(".show-more-btn");
        const showTextMore = showMore.querySelector(".show-text.more");
        const showTextLess = showMore.querySelector(".show-text.less");
        tags.forEach((tag, index)=>{
            if (index <= 3) tag.classList.add("active");
        });
        let currentVisibleIndex = 3;
        showMore.addEventListener("click", (e)=>{
            e.preventDefault();
            if (showTextMore.style.display !== "none") {
                let newLimit = tags.length - 1;
                tags.forEach((tag, index)=>{
                    if (index <= newLimit) tag.classList.add("active");
                });
                currentVisibleIndex = newLimit;
                if (currentVisibleIndex >= tags.length - 1) {
                    showTextMore.style.display = "none";
                    showTextLess.style.display = "inline";
                }
            } else {
                tags.forEach((tag, index)=>{
                    if (index > 3) tag.classList.remove("active");
                });
                currentVisibleIndex = 3;
                showTextMore.style.display = "inline";
                showTextLess.style.display = "none";
            }
        });
    }
};
var $cc7923cc3d4263e7$export$2e2bcd8739ae039 = $cc7923cc3d4263e7$var$ShowMore;


const $0a51eb07e18ed8d8$var$$ = jQuery;
const $0a51eb07e18ed8d8$var$ShowMoreGallery = {
    slider: $0a51eb07e18ed8d8$var$$(".gallery-images-slider"),
    init: ()=>{
        $0a51eb07e18ed8d8$var$ShowMoreGallery.slider.slick({
            infinite: true,
            centerMode: true,
            slidesToShow: 1,
            autoplay: false,
            dots: false,
            prevArrow: $0a51eb07e18ed8d8$var$$(".gallery-images-slider-bottom .gallery-images-slider-prev"),
            nextArrow: $0a51eb07e18ed8d8$var$$(".gallery-images-slider-bottom .gallery-images-slider-next"),
            adaptiveHeight: true,
            focusOnSelect: true
        });
        $0a51eb07e18ed8d8$var$ShowMoreGallery.slider.on("init reInit afterChange", function(event, slick, currentSlide, nextSlide) {
            var i = (currentSlide ? currentSlide : 0) + 1;
            $0a51eb07e18ed8d8$var$$(".gallery-images-slider-counter .current-count").text(i);
        });
        $0a51eb07e18ed8d8$var$$("[data-slidecount]").click(function(e) {
            $0a51eb07e18ed8d8$var$$("body").addClass("active-gallery-popup");
            var slideno = $0a51eb07e18ed8d8$var$$(this).data("slidecount");
            $0a51eb07e18ed8d8$var$ShowMoreGallery.slider.slick("slickGoTo", slideno - 1, true);
        });
        $0a51eb07e18ed8d8$var$$(".gallery-close").on("click", function() {
            $0a51eb07e18ed8d8$var$$("body").removeClass("active-gallery-popup");
        });
        // Pronađi wrapper galerije
        const galleryWrapper = document.querySelector(".gallery-images");
        if (!galleryWrapper) return;
        // Pronađi sve slike i dugme
        const galleryItems = document.querySelectorAll(".gallery-item");
        const showMoreButton = document.querySelector(".show-more-btn");
        const showTextMore = showMoreButton.querySelector(".show-text.more");
        const showTextLess = showMoreButton.querySelector(".show-text.less");
        // Prikaži samo prvih 4 slika
        galleryItems.forEach((item, index)=>{
            if (index <= 5) item.classList.add("active");
        });
        let currentVisibleIndex = 6;
        // Dodaj event listener na dugme
        showMoreButton.addEventListener("click", (e)=>{
            e.preventDefault();
            if (showTextMore.style.display !== "none") {
                // Prikaži sve slike
                let newLimit = galleryItems.length - 1;
                galleryItems.forEach((item, index)=>{
                    if (index <= newLimit) item.classList.add("active");
                });
                currentVisibleIndex = newLimit;
                if (currentVisibleIndex >= galleryItems.length - 1) {
                    showTextMore.style.display = "none";
                    showTextLess.style.display = "inline";
                }
            } else {
                // Sakrij dodatne slike
                galleryItems.forEach((item, index)=>{
                    if (index > 5) item.classList.remove("active");
                });
                currentVisibleIndex = 5;
                showTextMore.style.display = "inline";
                showTextLess.style.display = "none";
            }
        });
    }
};
var $0a51eb07e18ed8d8$export$2e2bcd8739ae039 = $0a51eb07e18ed8d8$var$ShowMoreGallery;


(0, $973b254601fecd3f$export$2e2bcd8739ae039).init();
(0, $cb6de554e11ef79b$export$2e2bcd8739ae039).init();
(0, $8bae1bbaa0bec04d$export$2e2bcd8739ae039).init();
(0, $cc7923cc3d4263e7$export$2e2bcd8739ae039).init();
(0, $0a51eb07e18ed8d8$export$2e2bcd8739ae039).init();

})();
//# sourceMappingURL=main.js.map
